module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am22-f19abd6dfdf05c666dde0230bbee8389.jpg";